import { formatRequest } from "../utils/function";
import axiosInstance from "./axiosInstance";

//customer fav product list
export function getCustomerFavProductList(data) {
  return axiosInstance.post(`customer-favourite-products/list`, formatRequest(data));
}

//customer fav product remove
export function customerFavProductRemove(data) {
  return axiosInstance.post(`customer-favourite-products/remove`, formatRequest(data));
}
export function customerFavProductSingleRemove(data) {
  return axiosInstance.post(`customer-favourite-products-single/remove`, formatRequest(data));
}



//customer fav product toggle visibility
export function customerFavProductToggleRemove(data) {
  return axiosInstance.post(`customer-favourite-products/toggle-visibility`, formatRequest(data));
}

//customer fav product save
export function createCustomerFavProduct(data) {
  return axiosInstance.post(`customer-favourite-products/save`, formatRequest(data));
}
